import AccessibilityNewIcon from '@mui/icons-material/AccessibilityNew';
import ContentPasteOutlinedIcon from '@mui/icons-material/ContentPasteOutlined';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import TaskIcon from '@mui/icons-material/Task';
import SettingsIcon from '@mui/icons-material/Settings';
import { Divider, List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import BuildCircleIcon from '@mui/icons-material/BuildCircle';
import CircleIcon from '@mui/icons-material/Circle';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';

import './style.css';
import { Fragment, useContext, useState } from 'react';
import { AuthContext } from '../auth/authContext';



export const SecondaryListItems = () => {

  const [onEstimate, setOnEstimate] = useState(false);
  const [onProducts, setOnProducts] = useState(false);
  const [onWorks, setOnWorks] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(1);

  const navigate = useNavigate();

  const handleRedirect = (destination) => {
    navigate(`/${destination}`)
  }

  const handleListItemClick = (event, index) => {
    setSelectedIndex(index);
  };

  const onProvisional = (event) => {
    handleListItemClick(event, 0)
    navigate('estimateTemporary')
  }
  const onAccept = (event) => {
    handleListItemClick(event, 1)
    navigate('estimateAccepted')
  }
  const onWork = (event) => {
    handleListItemClick(event, 2)
    navigate('estimateDefinitive')
  }
  const onServices = (event) => {
    handleListItemClick(event, 3)
    navigate('service')
  }
  const onRents = (event) => {
    handleListItemClick(event, 4)
    navigate('rent')
  }

  const onPendingAssembly = (event) => {
    handleListItemClick(event, 5)
    navigate('pendingAssembly')
  }
  const onAssembly = (event) => {
    handleListItemClick(event, 6)
    navigate('assembly')
  }
  const onPendingDisassembly = (event) => {
    handleListItemClick(event, 7)
    navigate('pendingDisassembly')
  }
  const onPendingCollection = (event) => {
    handleListItemClick(event, 8)
    navigate('pendingCollection')
  }
  const onFinished = (event) => {
    handleListItemClick(event, 9)
    navigate('finished')
  }

  const onNotCertificate = (event) => {
    handleListItemClick(event, 11)
    navigate('notCertificate')
  }
  const onDateCall = (event) => {
    handleListItemClick(event, 10)
    navigate('nextCall')
  }

  const { user } = useContext(AuthContext);

  return (
    <List component='nav'>
      <ListItemButton onClick={() => handleRedirect('')}>
        <ListItemIcon  >
          {/* poner logo pequeño */}
        </ListItemIcon>
        <ListItemText primary="Menu Principal" />
      </ListItemButton>
      <Divider />

      <ListItemButton onClick={() => handleRedirect('client')}>
        <ListItemIcon>
          <AccessibilityNewIcon />
        </ListItemIcon>
        <ListItemText primary="Clientes" />
      </ListItemButton>

      <ListItemButton onClick={() => {
        setOnEstimate(!onEstimate);
        handleRedirect('estimate');
      }}>
        <ListItemIcon>
          <ContentPasteOutlinedIcon />
        </ListItemIcon>
        <ListItemText primary="Presupuestos" />
        <ListItemIcon>
          <ArrowDropDownIcon />
        </ListItemIcon>
      </ListItemButton>

      {onEstimate &&
        <Fragment>
          <ListItemButton onClick={onProvisional} selected={selectedIndex === 0}>
            <ListItemIcon>
              <ContentPasteOutlinedIcon color='error' sx={{ marginLeft: '25px' }} fontSize='small' />
            </ListItemIcon>
            <ListItemText secondary="Provisionales" sx={{ pl: '1.5rem' }} />
          </ListItemButton>
          <ListItemButton selected={selectedIndex === 2} onClick={onWork}>
            <ListItemIcon>
              <ContentPasteOutlinedIcon color='success' sx={{ marginLeft: '25px' }} fontSize='small' />
            </ListItemIcon>
            <ListItemText
              sx={{ pl: '1.5rem' }}
              secondary="Definitivos"
            />
          </ListItemButton>
          <ListItemButton color='primary' selected={selectedIndex === 1} onClick={onAccept}>
            <ListItemIcon>
              <BuildCircleIcon color='success' sx={{ marginLeft: '25px' }} fontSize='small' />
            </ListItemIcon>
            <ListItemText
              sx={{ pl: '1.5rem' }}
              secondary="Aceptados"
            />
          </ListItemButton>
          <ListItemButton color='primary' selected={selectedIndex === 10} onClick={onDateCall}>
            <ListItemIcon>
              <LocalPhoneIcon color='success' sx={{ marginLeft: '25px' }} fontSize='small' />
            </ListItemIcon>
            <ListItemText
              sx={{ pl: '1.5rem' }}
              secondary="Próximas llamadas"
            />
          </ListItemButton>

        </Fragment>}

      <ListItemButton onClick={() => {
        setOnWorks(!onWorks)
        handleRedirect('works')
      }}>
        <ListItemIcon>
          <BuildCircleIcon />
        </ListItemIcon>
        <ListItemText primary="Obras" />
        <ListItemIcon>
          <ArrowDropDownIcon />
        </ListItemIcon>
      </ListItemButton>
      {onWorks &&
        <Fragment>
          <ListItemButton onClick={onPendingAssembly} selected={selectedIndex === 5}>
            <ListItemIcon >
              <CircleIcon color='error' sx={{ fontSize: '12px', marginLeft: '25px' }} />
            </ListItemIcon>
            <ListItemText secondary="Pendiente de montaje" />
          </ListItemButton>
          <ListItemButton color='primary' selected={selectedIndex === 6} onClick={onAssembly}>
            <ListItemIcon>
              <CircleIcon color='success' sx={{ fontSize: '12px', marginLeft: '25px' }} />
            </ListItemIcon>
            <ListItemText secondary="Montada" />
          </ListItemButton>
          <ListItemButton selected={selectedIndex === 7} onClick={onPendingDisassembly}>
            <ListItemIcon>
              <CircleIcon color='error' sx={{ fontSize: '12px', marginLeft: '25px' }} />
            </ListItemIcon>
            <ListItemText secondary="Pendiente de desmontaje" />
          </ListItemButton>
          <ListItemButton selected={selectedIndex === 8} onClick={onPendingCollection}>
            <ListItemIcon>
              <CircleIcon color='error' sx={{ fontSize: '12px', marginLeft: '25px' }} />
            </ListItemIcon>
            <ListItemText secondary="Pendiente de recogida" />
          </ListItemButton>
          <ListItemButton selected={selectedIndex === 9} onClick={onFinished}>
            <ListItemIcon >
              <CircleIcon color='error' sx={{ fontSize: '12px', marginLeft: '25px' }} />
            </ListItemIcon>
            <ListItemText secondary="Terminada" />
          </ListItemButton>
          <ListItemButton selected={selectedIndex === 11} onClick={onNotCertificate}>
            <ListItemIcon >
              <CircleIcon color='error' sx={{ fontSize: '12px', marginLeft: '25px' }} />
            </ListItemIcon>
            <ListItemText secondary="No certificadas" />
          </ListItemButton>
        </Fragment>
      }

      <ListItemButton onClick={() => handleRedirect('certification')}>
        <ListItemIcon>
          <AdminPanelSettingsOutlinedIcon />
        </ListItemIcon>
        <ListItemText primary="Certificaciones" />
      </ListItemButton>


      <ListItemButton onClick={() => {
        setOnProducts(!onProducts);
        handleRedirect('product')
      }}>
        <ListItemIcon>
          <TaskIcon />
        </ListItemIcon>
        <ListItemText primary="Productos" />
        <ListItemIcon>
          <ArrowDropDownIcon />
        </ListItemIcon>
      </ListItemButton>
      {onProducts &&
        <Fragment>
          <ListItemButton selected={selectedIndex === 3} onClick={onServices}>
            <ListItemText sx={{ pl: '5rem' }} primary="Servicios" />
          </ListItemButton>
          <ListItemButton selected={selectedIndex === 4} onClick={onRents}>
            <ListItemText sx={{ pl: '5rem' }} primary="Alquileres" />
          </ListItemButton>
        </Fragment>
      }

      {user.rol === 'Administrador' &&
        <ListItemButton onClick={() => handleRedirect('configuration')}>
          <ListItemIcon>
            <SettingsIcon />
          </ListItemIcon>
          <ListItemText primary="Configuración" />
        </ListItemButton>
      }
    </List >
  )
};